import withStyles from '@mui/styles/withStyles';
import MuiRating from '@mui/material/Rating';
import PropTypes from 'prop-types';
import React/* , { useMemo } */ from 'react';

const StyledRating = withStyles({
  icon: {
    adding: '0 10px 0 0',
    width: 24,
    height: 24,
  },
})(MuiRating);

const Rating = ({ itemStyle, onChange = () => {}, ...props }) => (
  <StyledRating
    {...props}
    style={itemStyle}
    // itemStyle={useMemo(
    //   () => ({
    //     padding: '0 10px 0 0',
    //     width: 24,
    //     height: 24,
    //     ...itemStyle,
    //   }),
    //   [itemStyle],
    // )}
    onChange={onChange}
  />
);

Rating.propTypes = {
  ...StyledRating.propTypes,
  itemStyle: PropTypes.object,
  onChange: PropTypes.func,
};

export default Rating;
